import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import StarOutlineOutlinedIcon from "@mui/icons-material/StarOutlineOutlined";
import ThreeSixtyOutlinedIcon from "@mui/icons-material/ThreeSixtyOutlined";
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined";
import BalanceOutlinedIcon from "@mui/icons-material/BalanceOutlined";
import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import RouteOutlinedIcon from "@mui/icons-material/RouteOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import AutoStoriesOutlined from "@mui/icons-material/AutoStoriesOutlined";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/logo.svg";

const navItems = [
  { label: "About", path: "/about" },
  { label: "Differentiation", path: "/differentiation" },
  {
    label: "Immersive Experience",
    path: "/immersive-experience",
  },
  { label: "Services", path: "/services" },
  { label: "Product Agnostic", path: "/product-agnostic" },
  { label: "Case Studies", path: "/case-study-dam-repository" },
  {
    label: "DAM Training",
    path: "/dam-trainiong-corporate",
  },
];

const navItemsHamburger = [
  {
    label: "About",
    path: "/about",
    icon: <PersonOutlineOutlinedIcon />,
  },
  {
    label: "Differentiation",
    path: "/differentiation",
    icon: <StarOutlineOutlinedIcon />,
  },
  {
    label: "Immersive Experience",
    path: "/immersive-experience",
    icon: <ThreeSixtyOutlinedIcon />,
  },
  { label: "Services", path: "/services", icon: <AppsOutlinedIcon /> },
  {
    label: "Product Agnostic",
    path: "/product-agnostic",
    icon: <BalanceOutlinedIcon />,
  },
  {
    label: "Case Studies",
    path: "/case-study-dam-repository",
    icon: <AutoStoriesOutlined />,
  },
  {
    label: "Discovery Framework",
    path: "/discovery-framework",
    icon: <ManageSearchOutlinedIcon />,
  },
  {
    label: "Our Practice",
    path: "/our-practice",
    icon: <WorkOutlineOutlinedIcon />,
  },
  {
    label: "DAM Journey",
    path: "/dam-journey",
    icon: <RouteOutlinedIcon />,
  },
  {
    label: "DAM Training",
    path: "/dam-trainiong-corporate",
    icon: <SchoolOutlinedIcon />,
  },
];

const policyItems = [
  { label: "Privacy Policy", path: "/privacy-policy" },
  { label: "Terms of Service", path: "/terms-of-use" },
  { label: "Cookie Policy", path: "/cookie-policy" },
];
const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery("(min-width:1201px)");
  const isTablet = useMediaQuery("(max-width:1520px)");
  const isMobile = useMediaQuery("(max-width:600px)");

  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (path) => {
    if (navigate) navigate(path);
    setDrawerOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          backgroundColor: "#ffffff",
          borderBottom: "none",
          boxShadow: "0px 4px 4px 0px #00000040",
        }}
      >
        <Toolbar
          sx={{
            //  maxWidth: "1440px",
            width: "100%",
            height: isDesktop ? "112px" : "92px",
            px: isDesktop ? "84px !important" : "16px !important",
            justifyContent: "space-between",
          }}
        >
          {/* Logo */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              gap: 1,
            }}
            onClick={() => handleNav("/")}
          >
            <Box
              component="img"
              src={logo}
              sx={{
                height: isDesktop ? "80px" : "60px",
                width: isDesktop ? "159px" : "120px",
              }}
            />
          </Box>

          {/* Desktop Navigation */}
          {!isTablet && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              {navItems.map((item) => (
                <Button
                  key={item.label}
                  onClick={() => handleNav(item.path)}
                  sx={{
                    textTransform: "none",
                    fontSize: "18px",
                    fontWeight: "medium",
                    color: isActive(item.path) ? "#ffffff" : "#333333",
                    backgroundColor: isActive(item.path)
                      ? "#2A2177"
                      : "transparent",
                    borderRadius: "8px",
                    px: 2,
                    py: 0.5,
                    minWidth: "auto",
                    whiteSpace: "nowrap",
                    "&:hover": {
                      backgroundColor: isActive(item.path)
                        ? "#0D47A1"
                        : "rgba(21, 101, 192, 0.08)",
                    },
                  }}
                >
                  {item.label}
                </Button>
              ))}

              {/* Contact Button */}
              <Button
                href="/contact"
                variant="contained"
                sx={{
                  textTransform: "none",
                  fontSize: "14px",
                  height: "36px",
                  fontWeight: 600,
                  color: "#ffffff",
                  backgroundColor: "#C22A43",
                  borderRadius: "20px",
                  px: 3,
                  py: 0.5,
                  ml: 1,
                  "&:hover": {
                    backgroundColor: "#B71C1C",
                  },
                }}
              >
                Contact
              </Button>
            </Box>
          )}

          {/* Mobile/Tablet Hamburger */}
          {isTablet && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Button
                href="/contact"
                variant="contained"
                sx={{
                  textTransform: "none",
                  fontSize: "14px",
                  height: "36px",
                  fontWeight: 600,
                  color: "#ffffff",
                  backgroundColor: "#C22A43",
                  borderRadius: "20px",
                  px: 3,
                  py: 0.5,
                  "&:hover": {
                    backgroundColor: "#B71C1C",
                  },
                }}
              >
                Contact
              </Button>
              <IconButton
                onClick={() => setDrawerOpen(true)}
                sx={{ color: "#333333" }}
                aria-label="Open navigation menu"
              >
                <MenuIcon />
              </IconButton>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      {/* Mobile/Tablet Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: isMobile ? "100%" : "360px",
            background: "linear-gradient(180deg, #EDE6F8, #EFE7D0)",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {/* Header with logo and close */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
            pt: 2,
            pb: 2,
            borderBottom: "1px solid #0000001A",
          }}
        >
          <Box
            component="img"
            src={logo}
            sx={{ width: "120px", height: "60px" }}
          />
          <IconButton
            onClick={() => setDrawerOpen(false)}
            aria-label="Close navigation menu"
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Menu title */}
        <Typography
          sx={{
            px: "28px",
            pt: 2,
            pb: 1,
            fontSize: "28px",
            fontWeight: 700,
          }}
        >
          Menu
        </Typography>

        {/* Nav items */}
        <List sx={{ px: "28px" }}>
          {navItemsHamburger.map((item) => (
            <ListItem
              button
              key={item.label}
              onClick={() => handleNav(item.path)}
              sx={{
                height: "52px",
                borderRadius: "8px",
                mb: 0.5,
                backgroundColor: isActive(item.path)
                  ? "#FAFAFA !important"
                  : "transparent",
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 40,
                  "& .MuiSvgIcon-root": { fontSize: "24px" },
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontSize: "1rem",
                  fontWeight: 600,
                  color: "#333333",
                }}
              />
            </ListItem>
          ))}
        </List>

        {/* Policy items */}
        <List sx={{ px: "28px", mt: 1 }}>
          {policyItems.map((item) => (
            <ListItem
              button
              key={item.label}
              onClick={() => handleNav(item.path)}
              sx={{
                height: "28px",
                py: 2.5,
              }}
            >
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontSize: "1rem",
                  fontWeight: 600,
                  color: "#333333",
                }}
              />
            </ListItem>
          ))}
        </List>

        {/* Copyright footer */}
        <Box
          sx={{
            mt: "auto",
            backgroundColor: "#2A2177",
            py: 2,
            px: 3,
          }}
        >
          <Typography
            sx={{
              color: "#ffffff",
              fontSize: "0.875rem",
              textAlign: "center",
            }}
          >
            © 2026 DAM Journey LLC. All rights reserved.
          </Typography>
        </Box>
      </Drawer>
    </>
  );
};

export default Header;
